@if(isDisabled){
<app-loader></app-loader>
}
<div class="card">
    <div class="card-header">
        <div class="row">
            <div class="col">Help Desk</div>
            <div class="col-auto">
                <span class="badge view" style="font-size: medium;height: auto;"> Total: {{this.globalTotal}}</span>
                &nbsp; <span class="badge view" style="font-size: medium;height: auto;"> Assigned:
                    {{this.globalAssign}}</span>
                &nbsp; <span class="badge view" style="font-size: medium;height: auto;"> Resolved:
                    {{this.globalResolved}}</span>
                &nbsp; <span class="badge view" style="font-size: medium;height: auto;"> Closed:
                    {{this.globalClose}}</span>
            </div>
        </div>
    </div>
    <div class="card-body">
        <div>
            <form (ngSubmit)="Validate(FilterForm)" #FilterForm="ngForm" name="FilterForm" novalidate>
                Period : {{showDate ?startFromDate :FromDateObj}} - {{showDate ?startToDate :ToDateObj}}
                <!-- From Date ( {{showDate ?startFromDate :FromDateObj}}) - To Date ({{showDate ?startToDate :ToDateObj}}) -->
                <div class="row">
                    <div class="col-md-3">
                        <div class="tile m-1 cursor-pointer" (click)="CardCountFilter('All')">
                            <div class="row" style="line-height: 30px;">
                                <div class="col-3 p-3 m-0 text-center" style="background-color: #0078D4;color: #fff;">
                                    <i class="bi bi-people fs-1"></i>
                                </div>
                                <div class="col-9 text-end p-0 m-0" style="background-color: #EBF3FE;color: #0078D4;">
                                    <div class="m-1" style="font-size:medium; font-weight: 500;">
                                        Total
                                    </div>
                                    <div class="m-1 count"
                                        style="font-size: xx-large;font-weight:400;line-height: 32px;">
                                        {{Total}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <!-- <div class="tile m-1 cursor-pointer" (click)="CardCountFilter('Assigned')">
                            <div class="row" style="line-height: 34px;">
                                <div class="col-3 p-3 m-0 text-center" style="background-color: #FF0000;color: #fff;">
                                    <i class="bi bi-person-x fs-1"></i>
                                </div>
                                <div class="col-9 text-end p-0 m-0" style="background-color: #FBF2EF;color: #FF0000;">
                                    <div class="m-1" style="font-size:medium; font-weight: 500;">
                                        Assigned
                                    </div>
                                    <div class="m-1 count"
                                        style="font-size: xx-large;font-weight:400;line-height: 32px;">
                                        {{Assigned}}
                                    </div>
                                </div>
                            </div>
                        </div> -->

                        <div class="tile m-1 cursor-pointer" (click)="CardCountFilter('Assigned')">
                            <div class="row" style="line-height: 34px;">
                                <!-- Left Side: Pink Background with White Text -->
                                <div class="col-3 p-3 m-0 text-center" style="background-color: #FF6347;color: #fff;">
                                    <i class="bi bi-person-x fs-1"></i>
                                </div>
                                
                                <!-- Right Side: Light Pink Background with Pink Text -->
                                <div class="col-9 text-end p-0 m-0" style="background-color: #FFE4E1;color: #FF6347;">
                                    <div class="m-1" style="font-size: medium; font-weight: 500;">
                                        Assigned
                                    </div>
                                    <div class="m-1 count" style="font-size: xx-large; font-weight: 400; line-height: 32px;">
                                        {{Assigned}}
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                    <div class="col-md-3">
                        <div class="tile m-1 cursor-pointer" (click)="CardCountFilter('Resolved')">
                            <div class="row" style="line-height: 30px;">
                                <div class="col-3 p-3 m-0 text-center" style="background-color: #ffcc00;color: #fff;">
                                    <i class="bi bi-cup-hot fs-1"></i>
                                </div>
                                <div class="col-9 text-end p-0 m-0" style="background-color: #f8edc1;color: #ffcc00;">
                                    <div class="m-1" style="font-size:medium; font-weight: 500;">
                                        Resolved
                                    </div>
                                    <div class="m-1 count"
                                        style="font-size: xx-large;font-weight:400;line-height: 32px;">
                                        {{Resolved}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="tile m-1 cursor-pointer" (click)="CardCountFilter('Closed')">
                            <div class="row" style="line-height: 34px;">
                                <div class="col-3 p-3 m-0 text-center" style="background-color: #00d68f;color: #fff;">
                                    <i class="bi bi-person-check fs-1"></i>
                                </div>
                                <div class="col-9 text-end p-0 m-0" style="background-color: #E6FFFA;color: #00d68f;">
                                    <div class="m-1" style="font-size:medium; font-weight: 500;">
                                        Closed
                                    </div>
                                    <div class="m-1 count"
                                        style="font-size: xx-large;font-weight:400;line-height: 32px;">
                                        {{Close}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <hr>
                <div class="row gx-3 mb-2">
                    <div class="col-md-3">
                        <label for="ComplaintType" class="Label">Complaint Type </label>
                        <ng-select [items]="ComplaintTypeData" bindLabel="ComplaintType" bindValue="ESS_ComplaintTypeID"
                            placeholder="Complaint Type" [(ngModel)]="ESS_ComplaintTypeId" [virtualScroll]="true"
                            name="ComplaintType" (change)="onchange('ComplaintType')">
                        </ng-select>
                        <div class="invalid-feedback">
                            Please select Complaint Type
                        </div>
                    </div>
                    <div class="col-md-2">
                        <label class="Label">Ticket status</label>
                        <select class="form-select" aria-label="TickecStatus" placeholder="TickecStatus"
                            title="TickecStatus" name="ticketstatus" [(ngModel)]="TickecStatus" required
                            (change)="onchange('Status')">
                            <option value="Assigned">Assigned</option>
                            <option value="Resolved">Resolved</option>
                            <option value="Closed">Closed</option>
                            <option value="All">All</option>
                        </select>
                    </div>
                    &nbsp;&nbsp; <div class="col-md-2"><br>
                        <input class="form-check-input" style="height: 15px; width: 15px;" name="filter" type="checkbox"
                            [(ngModel)]="showDate" value="" />&nbsp;&nbsp;<label style="font-size: 14px;">Filter by
                            Month</label>
                    </div>
                    <div class="col-md-2" *ngIf="!showDate">
                        <label class="Label">From Date</label>
                        <div class="input-group" style="height: auto;">
                            <input class="form-control" name="DateFrom" placeholder="Ex. DD MMM YYYY" ngbDatepicker
                                #d="ngbDatepicker" [(ngModel)]="FromDate" [minDate]="{ year:1930, month: 12, day: 31 }"
                                [maxDate]="{ year: 2124, month: 12, day: 31 }" readonly
                                (ngModelChange)="onchange('Date')" />
                            <button class="btn btn-outline-secondary bi bi-calendar3" (click)="d.toggle()"
                                type="button"></button>
                        </div>
                    </div>
                    <div class="col-md-2" *ngIf="!showDate">
                        <label class="Label">To Date</label>
                        <div class="input-group" style="height: auto;">
                            <input class="form-control" name="DateTo" placeholder="Ex. DD MMM YYYY" ngbDatepicker
                                #d3="ngbDatepicker" [(ngModel)]="ToDate" [minDate]="{ year:1930, month: 12, day: 31 }"
                                [maxDate]="{ year: 2124, month: 12, day: 31 }" readonly
                                (ngModelChange)="onchange('Date')" />
                            <button class="btn btn-outline-secondary bi bi-calendar3" (click)="d3.toggle()"
                                type="button"></button>
                        </div>
                    </div>
                    <div class="col-md-3" *ngIf="showDate">
                        <label class="Label">Month and Year</label>
                        <!-- <div class="input-group">
                                <select [(ngModel)]="selectedMonth" class="form-control" name="months"
                                    (change)="updateDate()">
                                    <option *ngFor="let month of months" [value]="month.value">{{ month.label }}</option>
                                </select>
                                <select [(ngModel)]="selectedYear" class="form-control" name="years"
                                    (change)="updateDate()">
                                    <option *ngFor="let year of years" [value]="year">{{ year }}</option>
                                </select>
                            </div> -->
                        <ngb-datepicker #dp [(ngModel)]="selectedMonth" class="month-year"
                            (navigate)="selectedMonth= $event.next;onNavigate()" name="dateselect"
                            style="width: 100%;"></ngb-datepicker>
                    </div>
                    <!-- <div class="col-auto"><br>
                            <button type="submit" name="Search" class="btn btn-primary" [disabled]="isDisabled">
                                <i class="bi bi-search" *ngIf="!isDisabled"></i>
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                    *ngIf="isDisabled"></span>
                                {{!isDisabled?'Search':'Loading...'}}
                            </button>
                        </div> -->
                </div><br>
                <div class="row gx-3 mb-2">
                    <div class="col-md-3">
                        <ng-select [items]="Branchs" [multiple]="true" bindLabel="BranchName" bindValue="BranchMasterID"
                            placeholder="Select Branch" [closeOnSelect]="false" [(ngModel)]="Filter.BranchID"
                            (change)="ComboLoad2('Client');onchange('Branch')" name="Branchs">
                            <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                                <input id="item-{{index}}" name="item-{{index}}" type="checkbox"
                                    [ngModel]="item$.selected" />
                                {{item.BranchName}}
                            </ng-template>
                            <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                                <div class="ng-value" *ngFor="let item of items.slice(0,1)">
                                    <span class="ng-value-label">{{item.BranchName}}</span>
                                </div>
                                <div class="ng-value" *ngIf="items.length > 1">
                                    <span class="ng-value-label">{{items.length - 1}} more...</span>
                                </div>
                            </ng-template>
                        </ng-select>
                    </div>
                    <div class="col-md-3">
                        <ng-select [items]="Clients" [multiple]="true" bindLabel="ClientGroupName"
                            bindValue="ClientGroupMasterID" placeholder="Select Clients" [closeOnSelect]="false"
                            [(ngModel)]="Filter.ClientID" (change)="ComboLoad2('Site');onchange('Client')"
                            name="Clients">
                            <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                                <input id="item-{{index}}" name="item-{{index}}" type="checkbox"
                                    [ngModel]="item$.selected" />
                                {{item.ClientGroupName}}
                            </ng-template>
                            <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                                <div class="ng-value" *ngFor="let item of items.slice(0,1)">
                                    <span class="ng-value-label">{{item.ClientGroupName}}</span>
                                </div>
                                <div class="ng-value" *ngIf="items.length > 1">
                                    <span class="ng-value-label">{{items.length - 1}} more...</span>
                                </div>
                            </ng-template>
                        </ng-select>
                    </div>
                    <div class="col-md-3">
                        <ng-select [items]="Sites" [multiple]="true" bindLabel="SiteName" bindValue="SiteMasterID"
                            placeholder="Select Site" [closeOnSelect]="false" [(ngModel)]="Filter.SiteID" name="Sites"
                            (change)="onchange('site')">
                            <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                                <input id="item-{{index}}" name="item-{{index}}" type="checkbox"
                                    [ngModel]="item$.selected" />
                                {{item.SiteName}}
                            </ng-template>
                            <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                                <div class="ng-value" *ngFor="let item of items.slice(0,1)">
                                    <span class="ng-value-label">{{item.SiteName}}</span>
                                </div>
                                <div class="ng-value" *ngIf="items.length > 1">
                                    <span class="ng-value-label">{{items.length - 1}} more...</span>
                                </div>
                            </ng-template>
                        </ng-select>
                    </div>
                    <div class="col-md-3">
                        <ng-select [items]="Supervisors" [multiple]="true" bindLabel="SiteOwnerName"
                            bindValue="SiteOwnerID" placeholder="Select Supervisor" [closeOnSelect]="false"
                            [(ngModel)]="Filter.SiteOwnerID" name="Supervisors" (change)="onchange('supervisor')">
                            <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                                <input id="item-{{index}}" name="item-{{index}}" type="checkbox"
                                    [ngModel]="item$.selected" />
                                {{item.SiteOwnerName}}
                            </ng-template>
                            <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                                <div class="ng-value" *ngFor="let item of items.slice(0,1)">
                                    <span class="ng-value-label">{{item.SiteOwnerName}}</span>
                                </div>
                                <div class="ng-value" *ngIf="items.length > 1">
                                    <span class="ng-value-label">{{items.length - 1}} more...</span>
                                </div>
                            </ng-template>
                        </ng-select>
                    </div>
                </div>
                <div class="row">
                    <div class="col">

                        <div class="row">
                        </div>
                        <div class="row">
                        </div>
                    </div>
                    <div class="col-auto">
                        <button type="submit" name="Search" class="btn btn-primary" [disabled]="isDisabled">
                            <i class="bi bi-search" *ngIf="!isDisabled"></i>
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                *ngIf="isDisabled"></span>
                            {{!isDisabled?'Search':'Loading...'}}
                        </button>
                    </div>
                </div>
            </form>
            <div class="card border-radius-0 mt-1 p-0">
                <div class="card-header">
                    Data
                </div>
                <div class="card-body p-1" style="overflow: auto;">
                    <table datatable [dtOptions]="common.commonDToptions" [dtTrigger]="dtTrigger"
                        class="customeDatatable table table-bordered">
                        <thead class="table-light">
                            <tr>
                                <!-- <th scope="col">#</th> -->
                                <th scope="col">Action</th>
                                <th scope="col">Complaint ID</th>
                                <th scope="col" style="display: none;">ESS_ComplaintType Id</th>
                                <th scope="col">Complaint Type</th>
                                <th scope="col" style="display: none;">AdditionalDetails</th>
                                <th scope="col" style="display: none;">EmpMasterId</th>
                                <!-- <th scope="col">Employee Code</th> -->
                                <th scope="col">Employee</th>
                                <th scope="col">ContactNo</th>
                                <th>Description</th>
                                <th>Attachment</th>
                                <th scope="col">Status</th>
                                <th scope="col" style="display: none;">RequestedBy</th>
                                <th scope="col">RequestedOn</th>
                                <th>Remark</th>
                                <th scope="col">Email</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let site of SupportData; let i = index" [ngClass]="{'sos-row': site['ComplaintType']  === 'SOS'}">
                                <!-- <th scope="row">{{ i + 1 }}</th>  [disabled]="site['Status'].toLowerCase() === 'closed'" -->
                                <td [ngClass]="{'highlight-row': site['PriorityFlag']  === 'PRIORITY'}">
                                    <button class="btn btn-sm btn-group-toggle" style="height: 50%; border: none;"
                                        name="act{{i}}" (click)="onEditClick(site)">
                                        <i class="bi bi-pencil-square text-warning"
                                            [ngClass]="{'disabled-button': site['Status'].toLowerCase() === 'closed'}"></i>
                                    </button>
                                </td>
                                <td [ngClass]="{'highlight-row': site['PriorityFlag']  === 'PRIORITY'}">{{ site['ESS_HelpDeskRequestID'] }}</td>
                                <td style="display: none;">{{ site['ESS_ComplaintTypeId'] }}</td>
                                <td [ngClass]="{'highlight-row': site['PriorityFlag']  === 'PRIORITY'}">{{ site['ComplaintType'] }}</td>
                                <td style="display: none;">{{ site['AdditionalDetails'] }}</td>
                                <td style="display: none;">{{ site['EmpMasterId'] }}</td>
                                <!-- <td>{{ site['EmpCode'] }}</td> -->
                                <!-- <td>{{ site['EmpName'] }}</td> -->
                                <td [ngClass]="{'highlight-row': site['PriorityFlag']  === 'PRIORITY'}">
                                    <div class="row no-gutters cursor-pointer"
                                        style="align-items: center;width: 300px;">
                                        <div class="col-2">
                                            <img *ngIf="site['Photo'] != null && site['Photo'] != ''" mat-card-image
                                                class="userImage" [src]="common.PhotoLink(site['Photo'])" />
                                            <div *ngIf="site['Photo'] == null || site['Photo'] == ''"
                                                class="initial-image">
                                                <div class="image">
                                                    {{common.getInitial(site['EmployeeName'])}}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-9 userdetail">
                                            <span class="text-label">{{site['EmpName']}}</span><br />
                                            <span class="text-label-light">#{{site['EmpCode']}}</span><br />
                                            <span class="text-label-light">{{site['DesignationName']}}</span>
                                        </div>
                                    </div>
                                </td>
                                <td [ngClass]="{'highlight-row': site['PriorityFlag']  === 'PRIORITY'}">{{ site['ContactNo'] }}</td>
                                <td [ngClass]="{'highlight-row': site['PriorityFlag']  === 'PRIORITY'}">{{ site['Description'] }}</td>
                                <td class="text-center" [ngClass]="{'highlight-row': site['PriorityFlag']  === 'PRIORITY'}"><a [href]="Link(site['Attachment'])" target="_blank"
                                    *ngIf="(site['Attachment'] == '' || site['Attachment'] == null)?false:true"><i
                                        class="bi bi-paperclip" style="font-size: 1.5rem;"
                                        [ngStyle]="{'color': site['PriorityFlag']  === 'PRIORITY' ? 'white' : null  }"></i></a></td>
                                        
                                <td [ngStyle]="{'color': site.Status === 'Open' ? 'orange' : 'green'}" [ngClass]="{'highlight-row': site['PriorityFlag']  === 'PRIORITY'}">{{ site['Status']
                                    }}</td>
                                <td style="display: none;">{{ site['RequestedBy'] }}</td>
                                <td [ngClass]="{'highlight-row': site['PriorityFlag']  === 'PRIORITY'}">{{ site['RequestedOn'] }}</td>
                                <td [ngClass]="{'highlight-row': site['PriorityFlag']  === 'PRIORITY'}">{{ site['Remarks'] }}</td>
                                <td [ngClass]="{'highlight-row': site['PriorityFlag']  === 'PRIORITY'}">{{site['Email']}}</td>
                            </tr>
                        </tbody>
                    </table>

                    <div class="row p-3">
                            <div class="col">
                                <div class="row">
                                    <div class="col-auto pb-1">
                                        <div class="row">
                                            <div class="col-auto rejected">
                                            </div>
                                            <div class="col-auto">
                                                SOS
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-auto pb-1">
                                        <div class="row">
                                            <div class="col-auto highlight-row">
                                            </div>
                                            <div class="col-auto">
                                                Over Due
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                </div>
            </div>
        </div>
    </div>
</div>